<template>
  <div class="loader u-bg-grey u-flex u-column u-center u-middle u-wrapper-panel">
    <img src="/images/sopra-logo.png" class="loader__logo u-marg-b-xl u-marg-b-lg--sm u-w8of12" alt="Logo img" :load="load" />
    <app-loader :load="load" class="u-w4of8 u-w10of12--sm"/>
  </div>
</template>

<script>

import AppLoader from '@/components/common/AppLoader'

export default {
  components: {
    AppLoader
  },

  props: {
    load: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="stylus">
.loader
  &__logo
    max-width 400px
</style>